import { render } from "./ReportsHome.vue?vue&type=template&id=07876142"
import script from "./ReportsHome.vue?vue&type=script&lang=js"
export * from "./ReportsHome.vue?vue&type=script&lang=js"

import "./ReportsHome.vue?vue&type=style&index=0&id=07876142&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__